import { render } from "./roster_contract.vue?vue&type=template&id=1386a010&scoped=true"
import script from "./roster_contract.vue?vue&type=script&lang=js"
export * from "./roster_contract.vue?vue&type=script&lang=js"

import "./roster_contract.vue?vue&type=style&index=0&id=1386a010&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1386a010"]])

export default __exports__